module.exports = "/_next/static/images/engaged-employees-a55e6eb5de6fbb3a85ed097dd776fc45.svg";